import { render, staticRenderFns } from "./TableFooterCurrentPage.vue?vue&type=template&id=aaf1020a&scoped=true&"
import script from "./TableFooterCurrentPage.vue?vue&type=script&lang=js&"
export * from "./TableFooterCurrentPage.vue?vue&type=script&lang=js&"
import style0 from "./TableFooterCurrentPage.vue?vue&type=style&index=0&id=aaf1020a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf1020a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
